// Campus photo for /colleges/virginia-commonwealth-university: CC BY 3.0, by Jeff Auth at English Wikipedia, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AVCU_Cabell_Library_by_Jeff_Auth.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/virginia-commonwealth-university/; credited under the photo.
const photo = {
    "slug": "virginia-commonwealth-university",
    "alt": "James Branch Cabell Library and its brick plaza on the Monroe Park Campus of Virginia Commonwealth University in Richmond",
    "src": "/colleges/virginia-commonwealth-university/campus-1600.webp",
    "srcSmall": "/colleges/virginia-commonwealth-university/campus-800.webp",
    "srcMid": "/colleges/virginia-commonwealth-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/virginia-commonwealth-university/og.jpg",
    "title": "VCU Cabell Library by Jeff Auth",
    "author": "Jeff Auth at English Wikipedia",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AVCU_Cabell_Library_by_Jeff_Auth.jpg",
    "read": "2026-10-02"
};

export default photo;
